import * as React from 'react';
import ImageIcon from '@mui/icons-material/Image';

const ImageIconWrapper = (props: any) => {
  return <ImageIcon {...props} />;
};

export default ImageIconWrapper;
